<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XHtqwG/tc-custom/9780253044815.jpg?1737121731133" alt="This image is the cover for the book Socialist Heritage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Socialist Heritage
      </h1>
      <p class="bookDescription body article font2">
        <b>This prize-winning study of post-WWII Romania examines the fraught relationship between national heritage and Socialist statecraft.</b><br/><br/>In <i>Socialist Heritage</i>, ethnographer and historian Emanuela Grama explores the socialist state’s attempt to create its own heritage, as well as the ongoing legacy of that project. While many argue that the socialist regimes of Central and Eastern Europe aimed to erase the pre-war history of the socialist cities, Grama shows that the communist state in Romania sought to exploit the past for its own benefit. <br/><br/>The book traces the transformation of Bucharest’s Old Town district from the early twentieth century into the twenty-first. Under socialism, politicians and professionals used the district’s historic buildings—especially the ruins of a medieval palace—to emphasize the city’s Romanian past and erase its ethnically diverse history. Since the collapse of socialism, the cultural and economic value of the Old Town has become highly contested. Its poor residents decry their semi-decrepit homes, while entrepreneurs see it as a source of easy money. <br/><br/>Such arguments point to recent negotiations about the meanings of class, political participation, and ethnic and economic belonging in today’s Romania. Grama’s rich historical and ethnographic research reveals the fundamentally dual nature of heritage: every search for an idealized past relies on strategies of differentiation that can lead to further marginalization and exclusion.<br/><br/><b>Winner of the 2020 Ed A. Hewitt Book Prize</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emanuela Grama
      </h2>
      
      <p class="authorDescription body article"><P><P>Emanuela Grama is Associate Professor of Anthropology and History at Carnegie Mellon University.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45ab2a03